import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Common } from '../model/common.model';
import { shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
// import 'rxjs/add/observable/throw';
// import 'rxjs/add/operator/catch';
// import 'rxjs/add/operator/map';

@Injectable()
export class DataService {
  
  constructor(private http: HttpClient) {
  }


  GetProductPageConfigurationsnew() {
var Allconfigurationlist=null;
    if (Allconfigurationlist == null || Allconfigurationlist == undefined || Allconfigurationlist == '') {
      try {
        Allconfigurationlist = JSON.parse(Common.getWithExpiry("GetProductPageConfigurations"));
      } catch (ed) { }
    }
    if (Allconfigurationlist == null || Allconfigurationlist == undefined || Allconfigurationlist == '') {
     this.GetProductPageConfigurations().subscribe((data: any) => {
        Allconfigurationlist = data;
        Common.setWithExpiry("GetProductPageConfigurations", JSON.stringify(Allconfigurationlist));        
      })
    }    
  }

  Getallconfigurations() {
    var allconfiglist = null;
    try {
      allconfiglist = JSON.parse(Common.getWithExpiry("Allconfigs"));
      return allconfiglist;
    } catch (ed) {
    }
    if (allconfiglist == undefined || allconfiglist == null || allconfiglist.length == 0) {

      this.GetAllConfiguration().subscribe((res: any) => {
        allconfiglist=res;
        Common.setWithExpiry("Allconfigs", JSON.stringify(res));
        return allconfiglist;
      });

    }
    
  }



  Getconfigbykey(Configkey) {
    var allconfiglist = null;
    var ConfigValue = '';
    try {
      allconfiglist = JSON.parse(Common.getWithExpiry("Allconfigs"));
    } catch (ed) {
    }
    if (allconfiglist != undefined && allconfiglist != null && allconfiglist.length > 0) {
      for (var i = 0; i < allconfiglist.length; i++) {
        if (Configkey == allconfiglist[i].ConfigKey) {
          ConfigValue = allconfiglist[i].ConfigValue;
          break;
        }
      }
    }
    return ConfigValue;
  }

  GettreenodebyNode(treenode) {
    return this.http.get(environment.APIUrl + '/Product/GettreenodebyNode?treenode=' + treenode, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetAllConfiguration() {
    return this.http.get(environment.APIUrl + '/usermodule/GetAllConfigurations', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getvisiblesitemapdata() {
    return this.http.get(environment.APIUrl + '/usermodule/Getvisiblesitemapdata', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetLoginPageConfigurations() {
    return this.http.get(environment.APIUrl + '/usermodule/GetLoginPageConfigurations', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetQuickAddPageConfigurations() {
    return this.http.get(environment.APIUrl + '/usermodule/GetQuickAddPageConfigurations', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getconfigforguestcheckout() {
    return this.http.get(environment.APIUrl + '/Product/Getconfigforguestcheckout', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetHomePageConfigurations() {
    return this.http.get(environment.APIUrl + '/usermodule/GetHomePageConfigurations', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetFooterPageConfigurations() {
    return this.http.get(environment.APIUrl + '/usermodule/GetFooterPageConfigurations', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetProductPageConfigurations() {
    return this.http.get(environment.APIUrl + '/usermodule/GetProductPageConfigurations', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetDashboardPageConfigurations() {
    return this.http.get(environment.APIUrl + '/usermodule/GetDashboardPageConfigurations', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetSidePageConfigurations() {
    return this.http.get(environment.APIUrl + '/usermodule/GetSidePageConfigurations', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetHeaderPageConfigurations() {
    return this.http.get(environment.APIUrl + '/usermodule/GetHeaderPageConfigurations', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigformodifyshipto() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigformodifyshipto', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getconfigforafterloginurl() {
    return this.http.get(environment.APIUrl + '/Product/Getconfigforafterloginurl', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigforwishlistlable() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigforwishlistlable', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigtowishlistproductsnote() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigtowishlistproductsnote', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetConfigforproductDDL() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigforproductDDL', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetConfigforNewItem() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigforNewItem', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getconfigurationnewitemdays() {
    return this.http.get(environment.APIUrl + '/Product/Getconfigurationnewitemdays', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  ConfigurationForpdfbuttonshow() {
    return this.http.get(environment.APIUrl + '/Product/ConfigurationForpdfbuttonshow', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigtomultiplewarehouseinone() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigtomultiplewarehouseinone', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetConfigforcolorpellet() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigforColorPellet', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetsetdefaultRESIDENTIAL() {
    return this.http.get(environment.APIUrl + '/Product/GetsetdefaultRESIDENTIAL', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  Getship_attn_required() {
    return this.http.get(environment.APIUrl + '/Product/Getship_attn_required', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getblind_ship() {
    return this.http.get(environment.APIUrl + '/Product/Getblind_ship', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getblind_ship_defaultCheck() {
    return this.http.get(environment.APIUrl + '/Product/Getblind_ship_defaultCheck', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetMultiplewarehouseforavaibility() {
    return this.http.get(environment.APIUrl + '/Product/GetMultiplewarehouseforavaibility', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetDisplayListPriceInProductListwithoutLogin() {
    return this.http.get(environment.APIUrl + '/Product/GetDisplayListPriceInProductListwithoutLogin', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetDisplayListPriceInProductListwithLogin() {
    return this.http.get(environment.APIUrl + '/Product/GetDisplayListPriceInProductListwithLogin', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getsetdefaultsafiltersclose() {
    return this.http.get(environment.APIUrl + '/Product/Getsetdefaultsafiltersclose', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigurationforProcesswithzeroprice() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigurationforProcesswithzeroprice', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  ConfigurationForPrintOrderReview() {
    return this.http.get(environment.APIUrl + '/Product/ConfigurationForPrintOrderReview', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetEmailTemplateofOrderhead() {
    return this.http.get(environment.APIUrl + '/UserModule/GetEmailTemplateofOrderhead', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetEmailTemplateofProductDetails() {
    return this.http.get(environment.APIUrl + '/UserModule/GetEmailTemplateofProductDetails', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getbeforepricelableinproductlist() {
    return this.http.get(environment.APIUrl + '/Product/Getbeforepricelableinproductlist', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getumafterpriceinproductlist() {
    return this.http.get(environment.APIUrl + '/Product/Getumafterpriceinproductlist', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getmanufacturerproductlist() {
    return this.http.get(environment.APIUrl + '/Product/Getmanufacturerproductlist', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetListPriceShow() {
    return this.http.get(environment.APIUrl + '/Product/GetListPriceShow', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetUMdropdown() {
    return this.http.get(environment.APIUrl + '/Product/GetUMdropdown', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetDescrToShow() {
    return this.http.get(environment.APIUrl + '/Product/GetDescrToShow', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetRMALable() {
    return this.http.get(environment.APIUrl + '/Product/GetRMALable', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetEnter_by_Default() {
    return this.http.get(environment.APIUrl + '/Product/GetconfigforEnter_by_Default', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetconfigforEnter_by() {
    return this.http.get(environment.APIUrl + '/Product/GetconfigforEnter_by', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetconfigforEnter_by_Lable() {
    return this.http.get(environment.APIUrl + '/Product/GetconfigforEnter_by_Lable', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetconfigurationforIsDisablePayment() {
    return this.http.get(environment.APIUrl + '/Product/GetconfigurationforIsDisablePayment', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetconfigforEnter_by_Required() {
    return this.http.get(environment.APIUrl + '/Product/GetconfigforEnter_by_Required', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  ConfigforIsProfileShow() {
    return this.http.get(environment.APIUrl + '/Product/ConfigforIsProfileShow', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  ConfigforProfileNo() {
    return this.http.get(environment.APIUrl + '/Product/ConfigforProfileNo', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  ConfigforProfileIndex() {
    return this.http.get(environment.APIUrl + '/Product/ConfigforProfileIndex', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  ConfigforProfileLable() {
    return this.http.get(environment.APIUrl + '/Product/ConfigforProfileLable', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  getRetailPriceConfg() {
    return this.http.get(environment.APIUrl + '/Product/getRetailPriceConfg', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  getRetailPriceLabel() {
    return this.http.get(environment.APIUrl + '/Product/getRetailPriceLabel', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  ConfigforIsARTotal() {
    return this.http.get(environment.APIUrl + '/Product/ConfigforIsARTotal', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  ConfigforSearchplaceholder() {
    return this.http.get(environment.APIUrl + '/Product/ConfigforSearchplaceholder', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  ConfigforSideMenuDefault() {
    return this.http.get(environment.APIUrl + '/Product/ConfigforSideMenuDefault', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  ConfigurationForLogoImageurl() {
    return this.http.get(environment.APIUrl + '/Product/ConfigurationForLogoImageurl', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  showpricetocustomers() {
    return this.http.get(environment.APIUrl + '/Product/showpricetocustomers', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getpagedatabyid(pageid) {
    return this.http.get(environment.APIUrl + '/usermodule/Getpagedatabyid?pageid='+pageid, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  ConfigurationForprintinvoice() {
    return this.http.get(environment.APIUrl + '/Product/ConfigurationForprintinvoice', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  ConfigurationFordocument() {
    return this.http.get(environment.APIUrl + '/Product/ConfigurationFordocument', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  ConfigurationFordocumentlable() {
    return this.http.get(environment.APIUrl + '/Product/ConfigurationFordocumentlable', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  ConfigurationForprintinvoicelable() {
    return this.http.get(environment.APIUrl + '/Product/ConfigurationForprintinvoicelable', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigForsameship() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigForsameship', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getconfigurationfrieghtcode() {
    return this.http.get(environment.APIUrl + '/Product/Getconfigurationfrieghtcode', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigForforgotpwdmsg() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigForforgotpwdmsg', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigurationforProcessTempOrder() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigurationforProcessTempOrder', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  cofigurtiondforLowestPriceFirst() {
    return this.http.get(environment.APIUrl + '/Product/cofigurtiondforLowestPriceFirst', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getavg_lead_time() {
    return this.http.get(environment.APIUrl + '/Product/Getavg_lead_time', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getavg_lead_time_lable() {
    return this.http.get(environment.APIUrl + '/Product/Getavg_lead_time_lable', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getconfigurationfornewestfirstsort() {
    return this.http.get(environment.APIUrl + '/Product/Getconfigurationfornewestfirstsort', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getconfigurationfornewestfirstsortlabel() {
    return this.http.get(environment.APIUrl + '/Product/Getconfigurationfornewestfirstsortlabel', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getavg_lead_time_value() {
    return this.http.get(environment.APIUrl + '/Product/Getavg_lead_time_value', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetDefaultredirect() {
    return this.http.get(environment.APIUrl + '/Product/GetDefaultredirect', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  cofigurtiondforhighestPriceFirst() {
    return this.http.get(environment.APIUrl + '/Product/cofigurtiondforhighestPriceFirst', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  cofigurtiondforItemAtoZ() {
    return this.http.get(environment.APIUrl + '/Product/cofigurtiondforItemAtoZ', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  cofigurtiondforItemZtoA() {
    return this.http.get(environment.APIUrl + '/Product/cofigurtiondforItemZtoA', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  cofigurtiondforLowestQtyFirst() {
    return this.http.get(environment.APIUrl + '/Product/cofigurtiondforLowestQtyFirst', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  cofigurtiondforhighestQtyFirst() {
    return this.http.get(environment.APIUrl + '/Product/cofigurtiondforhighestQtyFirst', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  cofigurtiondfordescrAtoZ() {
    return this.http.get(environment.APIUrl + '/Product/cofigurtiondfordescrAtoZ', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  cofigurtiondfordescrZtoA() {
    return this.http.get(environment.APIUrl + '/Product/cofigurtiondfordescrZtoA', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  cofigurtiondforQuantitySort() {
    return this.http.get(environment.APIUrl + '/Product/cofigurtiondforQuantitySort', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  cofigurtiondforDescrSort() {
    return this.http.get(environment.APIUrl + '/Product/cofigurtiondforDescrSort', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigForDisplaypriceinrfq() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigForDisplaypriceinrfq', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  cofigurtiondforHomePageCategoryLable() {
    return this.http.get(environment.APIUrl + '/Product/cofigurtiondforHomePageCategoryLable', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GettreenodeAdvance() {
    return this.http.get(environment.APIUrl + '/Product/GettreenodeAdvance', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetproductlineAdvance() {
    return this.http.get(environment.APIUrl + '/Product/GetproductlineAdvance', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetconfigforIsRelatedProduct() {
    return this.http.get(environment.APIUrl + '/Product/GetconfigforIsRelatedProduct', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetconfigforRelatedProductLable() {
    return this.http.get(environment.APIUrl + '/Product/GetconfigforRelatedProductLable', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  getCardtypelist() {
    return this.http.get(environment.APIUrl + '/UserModule/getCardtypelist', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigtoCartpagemessage() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigtoCartpagemessage', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigtoRegistrationLable() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigtoRegistrationLable', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  ConfigurationForItemDisclamier() {
    return this.http.get(environment.APIUrl + '/Product/ConfigurationForItemDisclamier', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigtocredicardtermcode() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigtocredicardtermcode', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  cofigurtiondfordrop_ship() {
    return this.http.get(environment.APIUrl + '/Product/cofigurtiondfordrop_ship', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  cofigurtiondfordrop_shiplable() {
    return this.http.get(environment.APIUrl + '/Product/cofigurtiondfordrop_shiplable', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetJobReleaselable() {
    return this.http.get(environment.APIUrl + '/Product/GetJobReleaselable', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  configforreorderfromorder() {
    return this.http.get(environment.APIUrl + '/Product/configforreorderfromorder', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  configforbreadcuminproductdetail() {
    return this.http.get(environment.APIUrl + '/Product/configforbreadcuminproductdetail', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  gettreenodebyitem(item) {
    var model = {
      "items": item
    }
    return this.http.post(environment.APIUrl + '/Product/gettreenodebyitem', model, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetProductListByRelatedItem(item, warehouse, company_sy) {
    var model = {
      "item": item,
      "warehouse": warehouse,
      "company_sy": company_sy
    }
    return this.http.post(environment.APIUrl + '/Product/GetProductListByRelatedItem', model, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  configforstocklable() {
    return this.http.get(environment.APIUrl + '/Product/configforstocklable', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  configforvendorinproductlist() {
    return this.http.get(environment.APIUrl + '/Product/configforvendorinproductlist', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigForOrderNoteLable() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigForOrderNoteLable', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetconfigurationfroAddressParser() {
    return this.http.get(environment.APIUrl + '/Product/GetconfigurationfroAddressParser', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigurationforPasswordPolicy() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigurationforPasswordPolicy', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigurationforaddb2bfields() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigurationforaddb2bfields', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigurationforViewTypeInProductListPage() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigurationforViewTypeInProductListPage', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigurationforTableView() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigurationforTableView', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetCustomerProductLable() {
    return this.http.get(environment.APIUrl + '/Product/GetCustomerProductLable', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetconfigforShowSAFilters() {
    return this.http.get(environment.APIUrl + '/Product/GetconfigforShowSAFilters', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigurationforSaFilterLable() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigurationforSaFilterLable', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigurationforPriceOrLable() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigurationforPriceOrLable', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigurationforProfilePriceLable() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigurationforProfilePriceLable', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  // GetFirstSysCompanyDetails() {
  //   return this.http.get(environment.APIUrl + '/DistoneApi/GetFirstSysCompanyDetails');
  // }
  GetDisplayListPriceLable() {
    return this.http.get(environment.APIUrl + '/Product/GetDisplayListPriceLable', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetDisplayListPriceInProductDetails() {
    return this.http.get(environment.APIUrl + '/Product/GetDisplayListPriceInProductDetails', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetDisplayListPriceInProductDetailswithoutLogin() {
    return this.http.get(environment.APIUrl + '/Product/GetDisplayListPriceInProductDetailswithoutLogin', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetContactUshtml() {
    return this.http.get(environment.APIUrl + '/Product/GetContactUshtml', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Gethelpdeskmenutype() {
    return this.http.get(environment.APIUrl + '/Product/Gethelpdeskmenutype', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigtoCategoryLableShow() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigtoCategoryLableShow', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigtoproductlineLableShow() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigtoproductlineLableShow', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigForAddToCartAsPerProfile() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigForAddToCartAsPerProfile', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigForTextUpperCaseSetting() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigForTextUpperCaseSetting', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigforfaxonxontactus() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigforfaxonxontactus', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetAddToCartAsPerProfileNo() {
    return this.http.get(environment.APIUrl + '/Product/GetAddToCartAsPerProfileNo', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetAddToCartAsPerProfileArrayNo() {
    return this.http.get(environment.APIUrl + '/Product/GetAddToCartAsPerProfileArrayNo', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GettermsandconditionsRequired() {
    return this.http.get(environment.APIUrl + '/Product/GettermsandconditionsRequired', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GettermsandconditionsLable() {
    return this.http.get(environment.APIUrl + '/Product/GettermsandconditionsLable', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Gettermsandconditions() {
    return this.http.get(environment.APIUrl + '/Product/Gettermsandconditions', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Geturloftermsandconditions() {
    return this.http.get(environment.APIUrl + '/Product/Geturloftermsandconditions', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfidForOrderBy() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigForOrderByshow', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetUrlWithDetailssetting() {
    return this.http.get(environment.APIUrl + '/Product/GetUrlWithDetailssetting', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetUrlWithFreeFormsetting() {
    return this.http.get(environment.APIUrl + '/Product/GetUrlWithFreeFormsetting', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfidForshowjobref() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigForshowshowjobref', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigtomailtoemailfromorder() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigtomailtoemailfromorder', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigtoDisplayUmQty() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigtoDisplayUmQty', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfidForSalesman() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigForSalesmanshow', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfidForshowtracking() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigForshowtrackingshow', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfidForcaptchaRegistration() {
    return this.http.get(environment.APIUrl + '/Product/GetConfidForcaptchaRegistration', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfidForCaptchaInContactUs() {
    return this.http.get(environment.APIUrl + '/Product/GetConfidForCaptchaInContactUs', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigforisprofiledesc() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigforisprofiledesc', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetSubmitTempOrderConfig() {
    return this.http.get(environment.APIUrl + '/Product/GetSubmitTempOrderConfig', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigurationforlable1() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigurationforlable1', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigurationforlable2() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigurationforlable2', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigurationforlable3() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigurationforlable3', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigurationforlable4() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigurationforlable4', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigurationforlable5() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigurationforlable5', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigurationforlable6() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigurationforlable6', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigurationforlable7() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigurationforlable7', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  getSalesmanNameByID(salesmanid) {
    var company_cu = Common.getWithExpiry("company_cu");
    return this.http.get(environment.APIUrl + '/Product/getSalesmanNameByID?salesmanid=' + salesmanid + '&company_cu=' + company_cu, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getlableforcustomerinforgotpassword() {
    return this.http.get(environment.APIUrl + '/Product/Getlableforcustomerinforgotpassword', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetlableforcuUserinforgotpassword() {
    return this.http.get(environment.APIUrl + '/Product/GetlableforcuUserinforgotpassword', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  getconfigforcheckoutmsg() {
    return this.http.get(environment.APIUrl + '/Product/getconfigforcheckoutmsg', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getconfigurationforurlfromreview() {
    return this.http.get(environment.APIUrl + '/Product/Getconfigurationforurlfromreview', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetViewTypeformultipleproduct() {
    return this.http.get(environment.APIUrl + '/Product/GetViewTypeformultipleproduct', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getpricebreakoneline() {
    return this.http.get(environment.APIUrl + '/Product/Getconfigurationforshowpricebreakoneline', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getconfigurationfroups() {
    return this.http.get(environment.APIUrl + '/Product/Getconfigurationfroups', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getthebaseitemconfiguration() {
    return this.http.get(environment.APIUrl + '/Product/Getthebaseitemconfiguration', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetpriceRoundingsetting() {
    return this.http.get(environment.APIUrl + '/Product/GetpriceRoundingsetting', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetMinOrdervalue() {
    var company = Common.getWithExpiry("company_sy");
    return this.http.get(environment.APIUrl + '/Product/GetMinOrdervalue?company=' + company, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigtoshowCreditLimit() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigtoshowCreditLimit', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetAllDevicenames1() {
    return this.http.get('http://ec2-52-91-50-53.compute-1.amazonaws.com/home/GetAllDevicesNames', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetAllDevicenames() {
    var getmodel = [];
    var getmodelnew= {
      "locationid": 27,
      "userid": "628cb2d43f21092d3878578b",
      "isedit": true,
      "locationname": "Nashville"
  }
  getmodel.push(getmodelnew);
    return this.http.post("http://studioautomation2.vustudio.network/api/values/Insertnewuserlocationmapping", getmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  getlatlng(address){    
    return this.http.get('https://maps.googleapis.com/maps/api/geocode/json?address=' + address);   
  }

  Gettroopsalesprofile(customer, username) {
    var getmodel = {
      customer: customer,
      UserName: username,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + "/UserModule/Getsalesprofilefortroop", getmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getpdfforhotboards(type, order, seq) {
    var mmodel = {
      type: type,
      order: order,
      seq: seq,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/Product/webBrowser1_Navigating', mmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetPdfForItemNotes(order, type) {
    var mmodel = {
      type: type,
      order: order,
      seq: '',
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/Product/Getitemnotespdf', mmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetOrderDocumentspdf(order, type, seq) {
    var mmodel = {
      type: type,
      order: order,
      seq: seq,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/Product/GetOrderDocumentspdf', mmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }




  Getconfigformanager() {
    return this.http.get(environment.APIUrl + '/Product/Getconfigformanager', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigFortheaddressshow() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigFortheaddressshow', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getconfigforitemlable() {
    return this.http.get(environment.APIUrl + '/Product/Getconfigforitemlable', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigurationbykey(configkey){
    return this.http.get(environment.APIUrl + '/Product/GetConfigurationbykey?configkey='+configkey, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetconfigforSequencelable() {
    return this.http.get(environment.APIUrl + '/Product/GetTheSequenceLable', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  SettingForUMDescription() {
    return this.http.get(environment.APIUrl + '/Product/SettingForUMDescription', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  warehousenamesetting() {
    return this.http.get(environment.APIUrl + '/Product/warehousenamesetting', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getwarehousenames() {
    return this.http.get(environment.APIUrl + '/Product/Getwarehousenames', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  getunitdescription() {
    return this.http.get(environment.APIUrl + '/Product/getunitdescription', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  showandhidewishinlist() {
    return this.http.get(environment.APIUrl + '/Product/showandhidewishinlist', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  showandhidecartinlist() {
    return this.http.get(environment.APIUrl + '/Product/showandhideAddtocartinlist', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  showandhiderfqinlist() {
    return this.http.get(environment.APIUrl + '/Product/showandhiderfqinlist', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetconfigurationforDisplayCounts() {
    return this.http.get(environment.APIUrl + '/Product/GetconfigurationforDisplayCounts', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetCountFormultipleproduct(item, warehouse) {
    var pmodel = {
      item: item,
      warehouse: warehouse,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/Product/GetCountFormultipleproduct', pmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetAllTotcodes() {
    var company_sy = Common.getWithExpiry("company_sy");
    return this.http.get(environment.APIUrl + '/Product/GetAlltotcodes?company_sy=' + company_sy, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfidForcaptcha() {
    return this.http.get(environment.APIUrl + '/Product/GetConfidForcaptcha', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigFortreesort() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigFortreesort', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigForsidecategorylabel() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigForsidecategorylabel', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetSAGroupColorCodeConfig() {
    return this.http.get(environment.APIUrl + '/Product/GetSAGroupColorCodeConfig', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigForsideproductlabel() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigForsideproductlabel', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigForProductlineshow() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigForProductlineshow', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getsy_prof_label() {
    var company_sy = Common.getWithExpiry("company_sy");
    return this.http.get(environment.APIUrl + '/Product/sy_prof_label?company_sy=' + company_sy, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigforprofilenoforitemdesc() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigforprofilenoforitemdesc', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigforarraynoforitemdesc() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigforarraynoforitemdesc', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigForZeroPrice() {
    return this.http.get(environment.APIUrl + '/Product/GetConfidForProductZero', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  getitemsearchinpurchasehistory() {
    return this.http.get(environment.APIUrl + '/usermodule/getitemsearchinpurchasehistory', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  getitemsearchincustomerproducts() {
    return this.http.get(environment.APIUrl + '/usermodule/getitemsearchincustomerproducts', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigForDimensions() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigForDimensions', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigForVendorinProductDetailspage() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigForVendorinProductDetailspage', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigForManufacturerinProductDetailspage() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigForMenufacturerinProductDetailspage', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigForisreorder() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigForisreorder', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigForisaddifunavail() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigForisaddifunavail', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigforProductNotAvailableinPurchasehistory() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigforProductNotAvailableinPurchasehistory', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigurationforshowwebiteminpurchasehistory() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigurationforshowwebiteminpurchasehistory', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Allowmultiuser() {
    return this.http.get(environment.APIUrl + '/Product/Allowmultiuser', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Loginlableformessage() {
    return this.http.get(environment.APIUrl + '/Product/Loginlableformessage', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  IsMultiCompanySetting() {
    return this.http.get(environment.APIUrl + '/UserModule/IsMultiCompanySetting', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetAllCompaniesList() {
    return this.http.get(environment.APIUrl + '/UserModule/GetAllCompaniesList', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetSysCompanyDetails(company) {
    return this.http.get(environment.APIUrl + '/DistOneAPi/GetSysCompanyDetails?company=' + company, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Loginmsgformessage() {
    return this.http.get(environment.APIUrl + '/Product/Loginmsgformessage', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Allowpricebreaks() {
    return this.http.get(environment.APIUrl + '/Product/Allowpricebreaks', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Allowmultipleum() {
    return this.http.get(environment.APIUrl + '/Product/Allowmultipleum', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  anonymoususersavailable() {
    return this.http.get(environment.APIUrl + '/Product/anonymoususersavailable', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Allowsaitemtags() {
    return this.http.get(environment.APIUrl + '/Product/Allowsaitemtags', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  msgdisplayforavaibility() {
    return this.http.get(environment.APIUrl + '/Product/msgdisplayforavaibility', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  msgdisplayforprice() {
    return this.http.get(environment.APIUrl + '/Product/msgdisplayforprice', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  ProductDetailsOrderConfig() {
    return this.http.get(environment.APIUrl + '/Product/ProductDetailsOrderConfig', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  anonymoususersIsstock() {
    return this.http.get(environment.APIUrl + '/Product/anonymoususersIsstock', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  withoutloginavaillist() {
    return this.http.get(environment.APIUrl + '/Product/withoutloginavaillist', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigForStockShow() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigForStockShow', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getheaderlinkslist() {
    return this.http.get(environment.APIUrl + '/Product/Getheaderlinkslist', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getfooterlinkslist() {
    return this.http.get(environment.APIUrl + '/Product/Getfooterlinkslist', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getdashboardlinkslist() {
    return this.http.get(environment.APIUrl + '/Product/Getdashboardlinkslist', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  pricemsgwithoutlogin() {
    return this.http.get(environment.APIUrl + '/Product/pricemsgwithoutlogin', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  qtymsgwithoutlogin() {
    return this.http.get(environment.APIUrl + '/Product/qtymsgwithoutlogin', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetaCOOKIENAME() {
    return this.http.get(environment.APIUrl + '/Product/GetaCOOKIENAME', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfidForlistprice() {
    return this.http.get(environment.APIUrl + '/Product/GetConfidForlistprice', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigForFastAddCart() {
    return this.http.get(environment.APIUrl + '/Product/GetConfidForFastAddCart', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  withloginprice() {
    return this.http.get(environment.APIUrl + '/Product/withloginprice', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  withloginpricelist() {
    return this.http.get(environment.APIUrl + '/Product/withloginpricelist', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  withloginavailshow() {
    return this.http.get(environment.APIUrl + '/Product/withloginavailshow', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  withloginavaillist() {
    return this.http.get(environment.APIUrl + '/Product/withloginavaillist', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  loginlabel1() {
    return this.http.get(environment.APIUrl + '/Product/loginlabel1', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  loginlabel2() {
    return this.http.get(environment.APIUrl + '/Product/loginlabel2', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  withloginavailqty() {
    return this.http.get(environment.APIUrl + '/Product/withloginavailqty', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetTreeListForAdvanceSearch() {
    var company_sy = Common.getWithExpiry("company_sy");
    return this.http.get(environment.APIUrl + '/Product/GetTreeListForAdvanceSearch?company_sy=' + company_sy, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  getacustomer(customer) {
    var cmodel = {
      customer: customer,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/UserModule/GetCustomerByID', cmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  getProduct(Menuname, PageNo, PageSize, warehouse, type) {
    var pcmap = {
      Menuname: Menuname,
      PageNo: PageNo,
      PageSize: PageSize,
      warehouse: warehouse,
      type: type,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/Product/GetProductListToDisplay', pcmap, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  getcustomerbysalesman(salesman) {
    var smodel = {
      salesman: salesman,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/UserModule/GetcustomerListbySalesman', smodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  getProductList(Menuname, pageNo, PageSize, warehouse, type, customer, satagsdetails,hideunavail) {
    var pmodel = {
      Menuname: Menuname,
      PageNo: pageNo,
      PageSize: PageSize,
      warehouse: warehouse,
      type: type,
      customer: customer,
      satagsdetails: satagsdetails,
      company_sy: Common.getWithExpiry("company_sy"),
      hideunavail:hideunavail,
      usercode: Common.getWithExpiry("usercode")
    }
    return this.http.post(environment.APIUrl + '/Product/GetProductListToDisplay', pmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  getProductListToDisplayCountNew(tree_node, BrandProduct, warehouse, satagsdetails,hideunavail) {
    var pmodel = {
      Menuname: tree_node,
      BrandProduct: BrandProduct,
      warehouse: warehouse,
      customer: Common.getWithExpiry("CustID"),
      satagsdetails: satagsdetails,
      company_sy: Common.getWithExpiry("company_sy"),
      hideunavail:hideunavail,
      usercode: Common.getWithExpiry("usercode")
    }
    return this.http.post(environment.APIUrl + '/Product/GetProductListToDisplayCountNew', pmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }


  getProductListToDisplayCount(productName, warehouse) {
    var pmodel = {
      Menuname: productName,
      warehouse: warehouse,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/Product/GetProductListToDisplayCount', pmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  getBrandProductListCount(productName, warehouse) {
    var pmodel = {
      Menuname: productName,
      warehouse: warehouse,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/Product/GetBrandProductListCount', pmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  getproductdetailforlist(types, name) {
    var company_sy = Common.getWithExpiry("company_sy");
    return this.http.get(environment.APIUrl + '/Product/getimageforproductlistpage?types=' + types + '&name=' + name + '&company_sy=' + company_sy, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }


  signinPunchout() {
    const headers = new HttpHeaders({ responseType: 'text', 'Content-Type': 'text/xml' }).set('Accept', 'text/xml');
    let body = '<?xml version = "1.0" encoding = "UTF-8"?>'
    '<request>'
    '<header version="1.0">'
    '<login>'
    '<username/>'
    '<password>welcome</password>'
    '</login>'
    '<action>shopping</action>'
    '<language>EN</language>'
    '<searchLanguage/>'
    '<userArea>'
    '<operatingUnit>204</operatingUnit>'
    '<shipTo>V1- New York City</shipTo>'
    '<deliverTo>V1- New York City</deliverTo>'
    '<fullName>Stock, Ms. Pat</fullName>'
    '<title>MS.</title>'
    '<manager>Brown, Ms. Casey</manager>'
    '<managerEmail>cbrown@vision.com</managerEmail>'
    '<location>V1- New York City</location>'
    '<language>US</language>'
    '<currency>USD</currency><dateFormat>DD-MON-RRRR</dateFormat>'
    '</userArea>'
    '</header>'
    '<body>'
    '<loginInfo>'
    '<exchangeInfo>'
    '<exchangeName>Oracle iProcurement</exchangeName>'
    '</exchangeInfo>'
    '<userInfo>'
    '<userName>Stock, Pat</userName>'
    '<userContactInfo>'
    '<userPhone/>'
    '<userEmail>pat.stock@vision.com</userEmail>'
    '</userContactInfo>'
    '<appUserName>OPERATIONS</appUserName>'
    '<userCompany>'
    '<companyName>Buyer Corp.</companyName>'
    '<companyDUNS>144709193</companyDUNS>'
    '<contactName/>'
    '<contactPhone/>'
    '</userCompany>'
    '</userInfo>'
    '<returnURL>http://qapache.us.oracle.com:15671/OA_'
    'HTML/OA.jsp?OAFunc=ICX_CAT_PUNCHOUT_CALLBACK&#38;OAHP=ICX_POR_HOMEPAGE_'
    'MENU&#38;OASF=ICX_CAT_PUNCHOUT_CALLBACK&#38;transactionid=1577779317</returnURL>'
    '</loginInfo>'
    '<partySiteId/>'
    '<searchKeywords/>'
    '<icxSessionCallBackURL/>'
    '</body>'
    '</request>';
    const hdr = { headers: headers, body: body };

    return this.http.post('https://66.128.132.126:8002/?event=account_login', hdr);
  }

  Getcategoriespath(param, stype) {
    var cmodel = {
      param: param,
      stype: stype,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/Product/Getcategoriespath', cmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetcategoriespathProductDetails(param) {
    var cmodel = {
      param: param,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/Product/GetProductDetailsBreadcum', cmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigfordecimalpoints() {
    return this.http.get(environment.APIUrl + '/Product/GetConfigfordecimalpoints', { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  getProductListBySearchCount(productName, warehouse, customer,hideunavail) {
    var model = {
      Menuname: productName,
      warehouse: warehouse,
      customer: customer,
      company_sy: Common.getWithExpiry("company_sy"),
      hideunavail:hideunavail,
      usercode: Common.getWithExpiry("usercode")
    }
    return this.http.post(environment.APIUrl + '/Product/GetProductListBySearchCount', model, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }


  getProductavailibity(itemlist) {
    itemlist.company_sy = Common.getWithExpiry("company_sy");
    return this.http.post(environment.APIUrl + '/DistOneAPi/itemavailability', itemlist, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  getProductListBySearch(searchText, pageNo, PageSize, warehouse, type, customer,hideunavail) {
    var pmodel = {
      word: searchText,
      PageNo: pageNo,
      PageSize: PageSize,
      warehouse: warehouse,
      type: type,
      customer: customer,
      company_sy: Common.getWithExpiry("company_sy"),
      hideunavail:hideunavail,
      usercode: Common.getWithExpiry("usercode")
    }
    return this.http.post(environment.APIUrl + '/Product/GetProductListBySearch', pmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetProductListBySearchforheader(searchText, pageNo, PageSize, warehouse, type, customer) {
    var pmodel = {
      word: searchText,
      PageNo: pageNo,
      PageSize: PageSize,
      warehouse: warehouse,
      type: type,
      customer: customer,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/Product/GetProductListBySearchforheader', pmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetProductAdvanceSearch(searchview) {
    searchview.company_sy = Common.getWithExpiry("company_sy");
    return this.http.post(environment.APIUrl + '/Product/GetAdvanceSearch', searchview, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetProductAdvanceSearchCount(searchview) {
    searchview.company_sy = Common.getWithExpiry("company_sy");
    return this.http.post(environment.APIUrl + '/Product/GetAdvanceSearchCount', searchview, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  getProductDetail(item, warehouse) {
    var pmodel = {
      itemnumber: item,
      warehouse: warehouse,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/Product/GetProductListByItemnumber', pmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  getProductDetailbyItemName(item, warehouse, customer) {
    var pmodel = {
      itemnumber: item,
      warehouse: warehouse,
      customer: customer,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/Product/GetProductListByItemNameNew', pmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetProductDetailsByItemNameNew(item, warehouse, customer, word) {
    var pmodel = {
      itemnumber: item,
      warehouse: warehouse,
      customer: customer,
      word: word,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/Product/GetProductDetailsByItemName', pmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetitemProfileDetails(item) {
    var pmodel = {
      item: item,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/UserModule/GetitemProfileDetails', pmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  getPriceBreaks(UserID, item) {
    var pmodel = {
      customer: UserID,
      item: item,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/DistOneAPi/GetPriceBreak', pmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  getProductDetailName(itemName, warehouse, customer) {
    var pmodel = {
      itemName: itemName,
      warehouse: warehouse,
      customer: customer,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/Product/GetProductListByItemName', pmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  getProductDetailNameForXref(itemName, warehouse, customer) {
    var pmodel = {
      itemName: itemName,
      warehouse: warehouse,
      customer: customer,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/Product/GetProductListByItemNameForXref', pmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  getproductcateloguepdf(Menuname,BrandProduct,warehouse,customer){
    var pmodel={
      Menuname:Menuname,
      BrandProduct:BrandProduct,
      warehouse:warehouse,
      customer:customer,
      company_sy:Common.getWithExpiry("company_sy"),
      hideunavail:false
    }
    return this.http.post(environment.APIUrl + '/Product/getproductcateloguepdf', pmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }


  getProductListByCategory(BrandProduct, pageNo, PageSize, warehouse, type, customer, satagsdetails,hideunavail) {
    var pmodel = {
      BrandProduct: BrandProduct,
      PageNo: pageNo,
      PageSize: PageSize,
      warehouse: warehouse,
      type: type,
      customer: customer,
      satagsdetails: satagsdetails,
      company_sy: Common.getWithExpiry("company_sy"),
      hideunavail:hideunavail,
      usercode: Common.getWithExpiry("usercode")
    }
    return this.http.post(environment.APIUrl + '/Product/GetProductListByBrandName', pmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  getBrandProduct(warehouse, customer) {
    var pmodel = {
      warehouse: warehouse,
      customer: customer,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + "/Product/GetBrandProductToDisplay", pmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  getMajProd() {
    return this.http.get(environment.APIUrl + "/Product/GetMajProd", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetWebsiteType() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetWebsiteType", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetlinebylineSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetlinebylineSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getaddnewqtywithnewlogic() {
    return this.http.get(environment.APIUrl + "/Product/Getaddnewqtywithnewlogic", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getdisplaynewavails() {
    return this.http.get(environment.APIUrl + "/Product/Getdisplaynewavails", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getdisplaynewavailslable() {
    return this.http.get(environment.APIUrl + "/Product/Getdisplaynewavailslable", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getavailsincart() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/Getavailsincart", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getinvoicepartialpayment() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/Getinvoicepartialpayment", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getachininvoice() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/Getachininvoice", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getachincheckout() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/Getachincheckout", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  Getconfigforcustomedropdown() {
    return this.http.get(environment.APIUrl + "/product/ConfigurationForcustomedropdown", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetcopypasteSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetcopypasteSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetfileuploadSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetfileuploadSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetTheChatCode() {
    return this.http.get(environment.APIUrl + "/Product/GetTheChatCode", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfidForanonymoususersbrowsethesite() {
    return this.http.get(environment.APIUrl + "/Product/GetConfidForanonymoususersbrowsethesite", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfidForanonymoususersPriceshow() {
    return this.http.get(environment.APIUrl + "/Product/GetConfidForanonymoususersPriceshow", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigForIsMuscle() {
    return this.http.get(environment.APIUrl + "/Product/GetConfigForIsMuscle", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getgetsalablesettings() {
    var company_sy = Common.getWithExpiry("company_sy");
    return this.http.get(environment.APIUrl + "/Product/getsalablesettings?company_sy=" + company_sy, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfidForGuestUserID() {
    return this.http.get(environment.APIUrl + "/Product/GetConfidForGuestUserID", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfidForGuestwarehouse() {
    var comapny_sy = Common.getWithExpiry("company_sy");
    return this.http.get(environment.APIUrl + "/Product/GetConfidForGuestwarehouse?comapny_sy=" + comapny_sy, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetMenuColor() {
    return this.http.get(environment.APIUrl + "/UserModule/GetMenuColor", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getmenufontcolor() {
    return this.http.get(environment.APIUrl + "/UserModule/Getmenufontcolor", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetTreeNodeValue() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetTreeNavigationValue", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetSocialLinks() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetSocialLinks", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  Getbusinesstype() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/Getbusinesstype", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetItemNotes(item) {
    var omodel = {
      keys: item,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + "/DistOneAPi/GetItemNotes", omodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetUserwishlist(username, type) {
    var umodel = {
      username: username,
      type: type
    }
    return this.http.post(environment.APIUrl + "/Product/GetUserwishlist", umodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetShippingMethodCalculate() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetShippingMethodConfig", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetUPSRateSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetUPSRateSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetUSPSRateSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetUSPSRateSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetFedExRateSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetFedExRateSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetFreeFormSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetFreeFormSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetItemNoteSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetItemNoteSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetProductDetailNote() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetProductDetailNote", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetOpenInvoicePaymentSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetOpenInvoicePaymentSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getwishlistfeatureonoff() {
    return this.http.get(environment.APIUrl + "/Product/GetConfigforwishlist", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  getconfigfortheheadermsg() {
    return this.http.get(environment.APIUrl + "/Product/getconfigfortheheadermsg", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  geturlforthelogo() {
    return this.http.get(environment.APIUrl + "/Product/geturlforthelogo", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getrfqlistfeatureonoff() {
    return this.http.get(environment.APIUrl + "/Product/GetConfigforrfqlist", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigurationforsa13sortdesc() {
    return this.http.get(environment.APIUrl + "/Product/GetConfigurationforsa13sortdesc", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigurationforsa13sortasc() {
    return this.http.get(environment.APIUrl + "/Product/GetConfigurationforsa13sortasc", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigurationforsa13sort() {
    return this.http.get(environment.APIUrl + "/Product/GetConfigurationforsa13sort", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetwishlistProductByID(wishlistId, customer) {
    var pmodel = {
      wishlistId: wishlistId,
      username: customer,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + "/Product/GetwishlistProductByID", pmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Deletewishlistbyusername(wishlistid) {
    var pmdoel = {
      wishlistId: wishlistid
    }
    return this.http.post(environment.APIUrl + "/Product/Deletewishlistbyusername", pmdoel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  AddProducttowishlist(WishlistitemID, WishlistID, item, Qty) {
    var modelnew = {
      WishlistitemID: WishlistitemID,
      WishlistID: WishlistID,
      item: item,
      Qty: Qty
    }
    return this.http.post(environment.APIUrl + '/Product/AddProducttowishlist', modelnew, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Addwishlistheader(WishlistID, WishlistName, username, shipto, type) {
    var modelnew = {
      WishlistID: WishlistID,
      WishlistName: WishlistName,
      username: username,
      shipto: shipto,
      type: type
    }
    return this.http.post(environment.APIUrl + '/Product/Addwishlistheader', modelnew, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  DeleteProducttowishlist(wishlistproductid) {
    var dmodel = {
      wishlistproductid: wishlistproductid
    }
    return this.http.post(environment.APIUrl + "/Product/DeleteProducttowishlist", dmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  DeleteAllProducttowishlist(wishlistId) {
    var dmodel = {
      wishlistId: wishlistId
    }
    return this.http.post(environment.APIUrl + "/Product/DeleteAllProducttowishlist", dmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetProductListForQuickOrder() {
    return this.http.get(environment.APIUrl + "/Product/GetProductListForQuickOrder", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }


  GetItemNotesimg(item, seq) {
    var pmodel = {
      category: 'it_note',
      key: item,
      seq: seq,
      max_width: '500',
      max_height: '500',
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + "/DistOneAPi/imagefetchcategory", pmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  getRemoteData(url): Observable<any> {
    return this.http.get(url);
    //    .map(this.extractData)
    //  .catch(this.handleError);
  }

  private extractData(res: Response) {
    let body = res.json();
    return body || {};
  }

  private handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';

    return Observable.throw(errMsg);
  }

  GetBrandList(warehouse, customer,usercode) {
    var pmodel = {
      warehouse: warehouse,
      customer: customer,
      company_sy: Common.getWithExpiry("company_sy"),
      usercode:usercode
    }
    return this.http.post(environment.APIUrl + '/Product/GetBrandList', pmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetShipToSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetShipToSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetWantedDateSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetWantedDateSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }


  GetCancelDateSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetCancelDateSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetJobReleaseSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetJobReleaseSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetPONumberSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetPONumberSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetContactNameSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetContactNameSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetEmailAddressSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetEmailAddressSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetShipViaSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetShipViaSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetShippingAccountSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetShippingAccountSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetPayTypeSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetPayTypeSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetNotesSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetNotesSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetPhoneSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetPhoneSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetShipCompleteSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetShipCompleteSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetSortingSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetSortingSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetPagingSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetPagingSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetProductView() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetProductView", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigForItemProfileshow() {
    return this.http.get(environment.APIUrl + "/Product/GetConfigForItemProfileshow", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetPendingOrderSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetPendingOrderSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetopenshipmentSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetopenshipmentSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetHelpDesksetting() {
    return this.http.get(environment.APIUrl + "/Product/GetHelpDesksetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetBackOrderItemsSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetBackOrderItemsSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetOpenInvoiceSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetOpenInvoiceSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetOrderHistorySetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetOrderHistorySetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetPurchaseHistorySetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetPurchaseHistorySetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetContractListSetting() {
    return this.http.get(environment.APIUrl + "/Product/GetConfigForContractlist", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetWantedDateRequired() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetWantedDateRequired", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetCancelDateRequired() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetCancelDateRequired", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetJobReleaseRequired() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetJobReleaseRequired", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetPhoneRequired() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetPhoneRequired", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetShipCompleteRequired() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetShipCompleteRequired", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetPORequired() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetPORequired", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetContactRequired() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetContactRequired", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetEmailRequired() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetEmailRequired", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetPayTypeRequired() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetPayTypeRequired", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetShipViaRequired() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetShipViaRequired", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetNoteRequired() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetNoteRequired", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetCreditCardSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetCreditCardSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetFeatureTitle() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetFeatureTitle", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetProfileTitle() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetProfileTitle", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetOverviewTitle() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetOverviewTitle", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  Get3DTitle() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/Get3DTitle", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  Get3DSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/Get3DSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  SalesLoginSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/SalesLoginSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getsecondaddressobjet() {
    return this.http.get(environment.APIUrl + "/Product/Getsecondaddressobjet", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  RegistrationSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/RegistrationSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Findmyidbyemailorphone(Email) {
    return this.http.get(environment.APIUrl + "/UserModule/Findmyidbyemailorphone?Email="+Email, { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }

  GuestLoginSetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GuestLoginSetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getalavartax() {
    return this.http.get(environment.APIUrl + "/UserModule/Getalavartax", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getchilditemlable() {
    return this.http.get(environment.APIUrl + "/UserModule/Getchilditemlable", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetavaibilitylableConfig() {
    return this.http.get(environment.APIUrl + "/product/GetavaibilitylableConfig", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getminlable() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/Getminlable", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  Getmaxlable() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/Getmaxlable", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  MinQtySetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/MinQtySetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  MaxQtySetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/MaxQtySetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetItemInProcessto(item,shipid,customer){
    var getmodel={
      shipid:shipid,
      customer:customer,
      userid:item
    }
    return this.http.post(environment.APIUrl + "/UserModule/GetItemInProcessto",getmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetItemInProcesstolist(listofitems){    
    return this.http.post(environment.APIUrl + "/UserModule/GetItemInProcesstolist",listofitems, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  MultiplySetting() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/MultiplySetting", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetConfigformsgonrfq() {
    return this.http.get(environment.APIUrl + "/DistOneAPi/GetConfigformsgonrfq", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  getHomeBanner() {
    return this.http.get(environment.APIUrl + "/product/getbanner", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  getfooterBanner() {
    return this.http.get(environment.APIUrl + "/product/GetfooterBanner", { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  get3dmodulehtml(iname, pname, cname) {
    var umodel = {
      iname: iname,
      pname: pname,
      cname: cname
    }
    return this.http.post(environment.APIUrl + '/UserModule/Get3dmodulehtml', umodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetPunchOutSessionDetail(custId, userId) {
    return this.http.get(environment.APIUrl + '/UserModule/GetPunchOutSessionDetail?custId=' + custId + '&userId=' + userId, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetSouthernPunchOutSessionDetail(buyerCookie) {
    return this.http.get(environment.APIUrl + '/UserModule/GetSouthernPunchOutSessionDetail?buyerCookie=' + buyerCookie, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  PunchOutCheckOut(url, model) {
    return this.http.post(url, model, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

 GetPermissionConfig() {
    return this.http.get(environment.APIUrl + '/Product/GetPermissionConfig');
  }

  GetCategoryCode(itemNo) {
    return this.http.get(environment.APIUrl + '/Product/GetCategoryCode?item='+itemNo, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' })});
  }

  GetWarehouse(customerId, company_cu, company_sy) {
    return this.http.get(environment.APIUrl + '/UserModule/GetWarehouse?customerId='+customerId+'&company_cu='+company_cu+'&company_sy='+company_sy, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' })});
  }

  DeleteSouthernCart(customerId, buyerCookie) {
    return this.http.get(environment.APIUrl + '/UserModule/DeleteSouthernCart?userId='+customerId+'&sessionId='+buyerCookie, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' })});
  }

  postSouthernOrderData(model) {
    return this.http.post(environment.APIUrl + '/DistOneAPi/PostSouthernOrderData', model, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
}
